module.exports = __webpack_public_path__ + "img/banner-3-mobile.bf122bc.webp";